export default __webpack_public_path__ + "static/media/ri_delete-bin-4-line.d08c40cd.svg";